/**
 * f16.1 (adr-6, BR-F16.1-9): the chart palette, read from the prototype's
 * `--chart-1` … `--chart-5` custom properties at runtime.
 *
 * SVG presentation attributes cannot resolve `var()`, so the RESOLVED values
 * are read once per mount and passed to Recharts as props. No colour literal
 * lives in code: switching the theme switches the tokens, and the next mount
 * reads them.
 */

import { useMemo } from 'react';

export const CHART_TOKENS = ['--chart-1', '--chart-2', '--chart-3', '--chart-4', '--chart-5'] as const;

/** The resolved token values, in order. `currentColor` where a token is not defined (e.g. jsdom). */
export function readChartPalette(root: Element = document.documentElement): string[] {
  const styles = getComputedStyle(root);
  return CHART_TOKENS.map((token) => styles.getPropertyValue(token).trim() || 'currentColor');
}

export function useChartPalette(): string[] {
  return useMemo(() => readChartPalette(), []);
}
